// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"12569fab","453":"67509adf"}[chunkId] + ".chunk.js";
};